var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "person_avatar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDDA5\\uFE0F-Back-Office",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B\\xE9n\\xE9ficaires",
    transform: "translate(-247.000000, -207.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "person_avatar",
    transform: "translate(247.000000, 207.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#6C2869",
    opacity: 0.1,
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(5.500000, 5.500000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 11 0 11 11 0 11"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#6C2869",
    strokeWidth: 0.792,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 5.5,
    cy: 3.20833333,
    r: 1.83333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75,9.625 L2.75,8.70833333 C2.75,7.69581129 3.57081129,6.875 4.58333333,6.875 L6.41666667,6.875 C7.42918871,6.875 8.25,7.69581129 8.25,8.70833333 L8.25,9.625",
    id: "Path",
    stroke: "#6C2869",
    strokeWidth: 0.792,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAvatar);
export default __webpack_public_path__ + "static/media/person_avatar.bc6e55efc16bf9b4401996263644dadf.svg";
export { ForwardRef as ReactComponent };